import { createModalsFactory } from 'ui';

import { SetupPeerPageModalIds, SetupPeerPageModalMeta } from './SetupPeerPage.types';

const {
  Provider: SetupPeerPageModalProvider,
  useProvider: useSetupPeerPageModalProvider,
  ModalTitleWithBackButton,
} = createModalsFactory<SetupPeerPageModalIds[], SetupPeerPageModalMeta>([
  'bannerImage',
  'description',
  'notifications',
  'complete',
]);

export { ModalTitleWithBackButton, SetupPeerPageModalProvider, useSetupPeerPageModalProvider };
